import { render, staticRenderFns } from "./settings-users.vue?vue&type=template&id=50233254&scoped=true&"
import script from "./settings-users.vue?vue&type=script&lang=js&"
export * from "./settings-users.vue?vue&type=script&lang=js&"
import style0 from "./settings-users.vue?vue&type=style&index=0&id=50233254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50233254",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50233254')) {
      api.createRecord('50233254', component.options)
    } else {
      api.reload('50233254', component.options)
    }
    module.hot.accept("./settings-users.vue?vue&type=template&id=50233254&scoped=true&", function () {
      api.rerender('50233254', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/settings/settings-users.vue"
export default component.exports